import EquipmentWebAPIUtils from 'utils/EquipmentWebAPIUtils';
import AdminConstants from 'constants/AdminConstants';
import AdminAppDispatcher from 'dispatcher/AdminAppDispatcher';
const ActionTypes = AdminConstants.ActionTypes;
export default {
    getAllEquipment(params) {
        EquipmentWebAPIUtils.getAllEquipment(params);
    },
    addEquipment(equipEntity) {
        EquipmentWebAPIUtils.addEquipment(equipEntity);
    },
    addEquipmentForStagingStop({ stagingShipmentId, sequence, equipment }) {
        AdminAppDispatcher.handleViewAction({
            type: ActionTypes.ADD_EQUIPMENT_FOR_STAGING_STOP_REQUEST,
            stagingShipmentId,
            sequence,
            equipment,
        });
    },
    updateEquipment(equipment) {
        EquipmentWebAPIUtils.updateEquipment(equipment);
    },
    bulkUpdateEquipments(equipments) {
        EquipmentWebAPIUtils.bulkUpdateEquipments(equipments);
    },
    getEquipmentAuditEvents(id) {
        EquipmentWebAPIUtils.getEquipmentAuditEvents(id);
    },
};
